import { FC, useState, useRef, useEffect } from 'react';
import {useIntl} from 'react-intl'

import {useFormik} from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'

import {Modal} from '../../../components/Modal'

import { ChatModel } from '../../../models/chat';
import { chatAPI } from '../../../api'
import { useChat, patchChat } from '../../../context/chat';

interface Props {
  chat: ChatModel
  show: boolean
  handleClose: () => void
}

const schema = Yup.object().shape({
  name: Yup.string().required('Required')
});


const ChatEditModal: FC<Props> = ({ chat, show, handleClose }) => {
  
  const intl = useIntl()

  const [handling, setHandling] = useState(false)

  const nameInputRef = useRef<HTMLInputElement | null>(null)

  const { dispatch } = useChat()

  const formik = useFormik({
    initialValues: {'name':chat.name},
    validationSchema: schema,
    onSubmit: (values) => {
      setHandling(true)
      chatAPI.updateName(chat.id, values.name).then(() => {
        dispatch(patchChat({...chat, name: values.name}))
        handleClose()
      }).finally (() => {
        setHandling(false)
      })
    },
  })

  useEffect(() => { 
    if (nameInputRef.current) {
      nameInputRef.current.focus();
    }
  }, [show])

  return <Modal show={show} handleClose={handleClose} title={intl.formatMessage({id: 'chat.edit_name.title'})} dialogClassName="">
    <form
        className='form fv-plugins-bootstrap5 fv-plugins-framework'
        onSubmit={formik.handleSubmit}
        noValidate
      >
      <div className="d-flex flex-column mb-5 fv-row fv-plugins-icon-container">
        <input 
          type="text" 
          placeholder={intl.formatMessage({id: 'chat.edit_name.placeholder'})}  
          ref={nameInputRef}
          {...formik.getFieldProps('name')}
          className={clsx(
            'form-control bg-transparent h-60px border border-gray-400',
            {'is-invalid': formik.touched.name && formik.errors.name},
            {
              'is-valid': formik.touched.name && !formik.errors.name,
            }
          )}/>
        </div>
        <div className="text-center">
          <button
            type='submit'
            className="btn btn-primary"
            disabled={handling || !formik.isValid}
          >
            {!handling && <span className='indicator-label'>{intl.formatMessage({id: 'chat.edit_name.submit'})}</span>}
            {handling && (
              <span className='indicator-progress' style={{display: 'block'}}>
                {intl.formatMessage({id: `general.please_wait`})}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            )}
          </button>
          
          <button type="button" className="btn btn-light ms-3" onClick={handleClose}>
            {intl.formatMessage({id: 'general.close'})}
          </button>
        </div>
      </form>
    </Modal>
  }
  
  export {ChatEditModal}